module.exports = __webpack_public_path__ + "static/media/team3.95815e13.webp";